var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-4 border-b border-gray-200 tabs-panel w-full",
    attrs: {
      "id": _vm.tabsId,
      "lazy-load": _vm.lazyLoad,
      "query-tab": _vm.queryTab
    }
  }, [_c('ul', {
    staticClass: "flex flex-wrap -mb-px text-sm font-medium text-center",
    class: [_vm.alignClass],
    attrs: {
      "data-tabs-toggle": `#${_vm.tabContentId}`,
      "role": "tablist"
    }
  }, [_vm._t("header")], 2)]), _c('div', {
    attrs: {
      "id": _vm.tabContentId
    }
  }, [_vm._t("content")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }